"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var API_URL = {
  DEVELOPMENT: {
    LFC_API_URL: 'https://flights.devairasia.{domain}/fp/lfc/v1/lowfare'
  },
  STAGING: {
    LFC_API_URL: 'https://flights.stgairasia.{domain}/fp/lfc/v1/lowfare'
  },
  PRE_PRODUCTION: {
    LFC_API_URL: 'https://flights.ppairasia.{domain}/fp/lfc/v1/lowfare'
  },
  PRODUCTION: {
    LFC_API_URL: 'https://flights.airasia.{domain}/fp/lfc/v1/lowfare'
  }
};
var _default = API_URL;
exports.default = _default;